/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSavedPaymentMethod200ResponseProvider } from './GetSavedPaymentMethod200ResponseProvider';
import {
    GetSavedPaymentMethod200ResponseProviderFromJSON,
    GetSavedPaymentMethod200ResponseProviderFromJSONTyped,
    GetSavedPaymentMethod200ResponseProviderToJSON,
    GetSavedPaymentMethod200ResponseProviderToJSONTyped,
} from './GetSavedPaymentMethod200ResponseProvider';
import type { GetSavedPaymentMethodRequestType } from './GetSavedPaymentMethodRequestType';
import {
    GetSavedPaymentMethodRequestTypeFromJSON,
    GetSavedPaymentMethodRequestTypeFromJSONTyped,
    GetSavedPaymentMethodRequestTypeToJSON,
    GetSavedPaymentMethodRequestTypeToJSONTyped,
} from './GetSavedPaymentMethodRequestType';

/**
 * 
 * @export
 * @interface GetSavedPaymentMethod200Response
 */
export interface GetSavedPaymentMethod200Response {
    /**
     * 
     * @type {string}
     * @memberof GetSavedPaymentMethod200Response
     */
    id: string;
    /**
     * 
     * @type {GetSavedPaymentMethod200ResponseProvider}
     * @memberof GetSavedPaymentMethod200Response
     */
    provider: GetSavedPaymentMethod200ResponseProvider;
    /**
     * 
     * @type {GetSavedPaymentMethodRequestType}
     * @memberof GetSavedPaymentMethod200Response
     */
    type: GetSavedPaymentMethodRequestType;
    /**
     * 
     * @type {string}
     * @memberof GetSavedPaymentMethod200Response
     */
    last4: string;
    /**
     * 
     * @type {string}
     * @memberof GetSavedPaymentMethod200Response
     */
    brand: string;
    /**
     * 
     * @type {string}
     * @memberof GetSavedPaymentMethod200Response
     */
    holderName?: string;
    /**
     * 
     * @type {number}
     * @memberof GetSavedPaymentMethod200Response
     */
    expiryMonth?: number;
    /**
     * 
     * @type {number}
     * @memberof GetSavedPaymentMethod200Response
     */
    expiryYear?: number;
    /**
     * 
     * @type {string}
     * @memberof GetSavedPaymentMethod200Response
     */
    creationTime: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSavedPaymentMethod200Response
     */
    requiresAction?: boolean;
}

/**
 * Check if a given object implements the GetSavedPaymentMethod200Response interface.
 */
export function instanceOfGetSavedPaymentMethod200Response(value: object): value is GetSavedPaymentMethod200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('last4' in value) || value['last4'] === undefined) return false;
    if (!('brand' in value) || value['brand'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    return true;
}

export function GetSavedPaymentMethod200ResponseFromJSON(json: any): GetSavedPaymentMethod200Response {
    return GetSavedPaymentMethod200ResponseFromJSONTyped(json, false);
}

export function GetSavedPaymentMethod200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSavedPaymentMethod200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'provider': GetSavedPaymentMethod200ResponseProviderFromJSON(json['provider']),
        'type': GetSavedPaymentMethodRequestTypeFromJSON(json['type']),
        'last4': json['last4'],
        'brand': json['brand'],
        'holderName': json['holderName'] == null ? undefined : json['holderName'],
        'expiryMonth': json['expiryMonth'] == null ? undefined : json['expiryMonth'],
        'expiryYear': json['expiryYear'] == null ? undefined : json['expiryYear'],
        'creationTime': json['creationTime'],
        'requiresAction': json['requiresAction'] == null ? undefined : json['requiresAction'],
    };
}

export function GetSavedPaymentMethod200ResponseToJSON(json: any): GetSavedPaymentMethod200Response {
    return GetSavedPaymentMethod200ResponseToJSONTyped(json, false);
}

export function GetSavedPaymentMethod200ResponseToJSONTyped(value?: GetSavedPaymentMethod200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'provider': GetSavedPaymentMethod200ResponseProviderToJSON(value['provider']),
        'type': GetSavedPaymentMethodRequestTypeToJSON(value['type']),
        'last4': value['last4'],
        'brand': value['brand'],
        'holderName': value['holderName'],
        'expiryMonth': value['expiryMonth'],
        'expiryYear': value['expiryYear'],
        'creationTime': value['creationTime'],
        'requiresAction': value['requiresAction'],
    };
}

